export var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["EN"] = "en";
    SupportedLanguage["FR"] = "fr";
    SupportedLanguage["AR"] = "ar";
    SupportedLanguage["DE"] = "de";
    SupportedLanguage["ES"] = "es";
    SupportedLanguage["HI"] = "hi";
    SupportedLanguage["KO"] = "ko";
    SupportedLanguage["PT"] = "pt";
    SupportedLanguage["RU"] = "ru";
})(SupportedLanguage || (SupportedLanguage = {}));
